// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'






import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import App from './App'
import router from './router'
import store from './store'
import api from '../common/api.js'
Vue.prototype.api = api

import './assets/css/reset.css'
import './assets/css/global.css'
import './assets/fonts/iconfont.css'

import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable)
// 封装组件
import timeChang from './components/timeChang.vue'
Vue.component('timeChang', timeChang)
// 封装命名组件
import Tree from "./components/Tree.vue";
Vue.component('Tree', Tree)

// 图形验证
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

import xPopup from './components/x-popup.vue'
Vue.component('xPopup', xPopup)
import xButton from './components/xButton.vue'
Vue.component('xButton', xButton)
import xSelectTree from './components/x-select-tree.vue'
Vue.component('xSelectTree', xSelectTree)
import clsManage from './components/cls_manage.vue'
Vue.component('clsManage', clsManage)

// 请求
import axios from 'axios';
Vue.prototype.axios = axios

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
import geoJson from './assets/js/china.json'
echarts.registerMap('china', geoJson);

//表格导出
Vue.prototype.fExportDataEvent = async (table, qxName) => {
  //由于外部取不到table 所以需要通过函数调用用时传参 来找到该表格
  table.exportData({
    type: 'csv'
  })
}
//线上环境去掉console.log
if (process.env.NODE_ENV === 'production') {
  if (window) {
    window.console.log = function() {};
  }
}
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js